module.exports = __webpack_public_path__ + "img/Medical_application_pic.4c9858ba.png";